import { defineMessages } from "react-intl";
const messages = defineMessages({
    contactSales: {
        id: "app.components.banner.contactSales.text",
        defaultMessage: "Contact Sales",
    },
    learnMore: {
        id: "app.components.learnMore.text",
        defaultMessage: "Learn More",
    },
});
export default messages;
